import { makeStyles } from "@material-ui/core";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 12,
    height: 4,
    borderRadius: 4,
    marginRight: theme.spacing(1.2),
    boxSizing: "border-box",
  },
}));

export const ColorIndicator = ({ color, onlyBorder, style }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      style={{
        backgroundColor: onlyBorder ? undefined : color,
        border:
          color === COLORS.white
            ? `1px solid ${COLORS.darks[0][50]}`
            : onlyBorder
            ? `2px dotted ${color}`
            : color.startsWith("#000") || color.startsWith(COLORS.darks[0][100])
            ? `1px solid ${COLORS.white}`
            : null,
        ...style,
      }}
    ></div>
  );
};
